module.exports = __webpack_public_path__ + "static/media/iso-certification.b015ff5b.svg";